import { FC } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { theme } from '../../theme';
import dateFormat from 'dateformat';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export type Chart = {
  result_date: Date;
  value: number;
};

export interface IButtonChart {
  display_name: string;
  chartData: Chart[];
}

const ButtonChart: FC<IButtonChart> = ({ display_name, chartData }) => {
  const { primary } = theme.color;
  const { type } = theme;
  const labels = chartData.map(({ result_date }) => dateFormat(new Date(result_date), 'm/d'));
  const rawData = chartData.map(({ value }) => value);

  const _options = {
    responsive: true,
    aspectRatio: 1,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: display_name.toUpperCase(),
        font: {
          size: 16,
          family: type.face,
        },
        padding: {
          bottom: 24,
        },
      },
    },
  };

  const _data = {
    labels,
    datasets: [
      {
        label: display_name,
        data: rawData,
        borderColor: primary.regular,
        backgroundColor: primary.regular,
      },
    ],
  };

  return <Line data={_data} options={_options} />;
};

export default ButtonChart;
